import { updateDealLine } from '../../services/dealLines';
import { dealOfPhase } from '../../utils/phases';
import { lineWithPhaseDates } from './phaseDraftLine';

const numOrNull = (v) => (v === '' || v == null ? null : parseFloat(v));

/* Affaires avec leurs lignes, rechargées si l'écran courant ne les a pas encore (page Projets
   ouverte directement) : sans elles, une phase ne retrouve pas son affaire d'origine. */
export async function currentDeals(deals, api) {
  if (deals && deals.length) return deals;
  return (await api.loadDeals?.()) || [];
}

/* Dates d'une phase convertie reportées sur sa ligne vendue : les dates se pilotent depuis le
   projet, le CA du CRM et l'engagement suivent (clôture, prolongation, décalage). */
export async function syncLineDates({ deals, setDeals }, phase, dateDebut, dateFin) {
  if (!phase?.ligneId) return;
  const aff = dealOfPhase(deals, phase);
  const line = (aff?.lignes || []).find((l) => l.id === phase.ligneId);
  if (!line) return;
  const next = lineWithPhaseDates(line, { date_debut: dateDebut, date_fin: dateFin });
  if (next === line) return;
  await updateDealLine(line.id, {
    date_debut_prevue: next.date_debut_prevue || null,
    date_fin_prevue: next.date_fin_prevue || null,
    engagement_mois_vendu: numOrNull(next.engagement_mois_vendu),
  });
  setDeals((list) =>
    list.map((a) =>
      a.id === aff.id ? { ...a, lignes: a.lignes.map((l) => (l.id === line.id ? next : l)) } : a,
    ),
  );
}

/* Phase clôturée avant de commencer = annulation (arbitrage du 2026-10-02) : sa ligne vendue est
   marquée annulée et ne compte plus dans le CA, sans toucher au montant signé ni aux dates. */
export async function cancelLine({ deals, setDeals }, phase) {
  if (!phase?.ligneId) return;
  const aff = dealOfPhase(deals, phase);
  if (!aff) return;
  await updateDealLine(phase.ligneId, { annulee: true });
  setDeals((list) =>
    list.map((a) =>
      a.id === aff.id
        ? {
            ...a,
            lignes: a.lignes.map((l) => (l.id === phase.ligneId ? { ...l, annulee: true } : l)),
          }
        : a,
    ),
  );
}
